/** @format */

import {VideoLibraryOutlined} from '@mui/icons-material';

import {useNavigate} from 'react-router-dom';

import {BlueButton} from 'components/buttons/BlueButton';

import {ROUTES} from 'constants/ROUTES';

import {HintArrow, HintBox, HintText, Root} from './styles';

import arrowImg from './images/arrow.svg';

const LearnVideo = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${ROUTES.HELP_MATERIALS}#digital-cast`);
  };

  return (
    <Root>
      <HintBox>
        <HintText>Узнайте, как настроить проект с медиапланом</HintText>
        <HintArrow src={arrowImg} alt='' />
      </HintBox>

      <BlueButton size='large' onClick={handleClick}>
        <VideoLibraryOutlined />
        Обучающее видео
      </BlueButton>
    </Root>
  );
};

export {LearnVideo};
